/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MailMagazineManagementCreateMailMagazineResponse } from './MailMagazineManagementCreateMailMagazineResponse';

export type MailMagazineManagementCreateMailMagazineResponseApiRespoonse = {
    data?: MailMagazineManagementCreateMailMagazineResponse;
    status?: MailMagazineManagementCreateMailMagazineResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MailMagazineManagementCreateMailMagazineResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

